import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import familiesCaringbg from "../assets/images/familiesCaringBg.jpg";
import Breadcrumbs from "../components/Breadcrumbs";
import Counter from "../components/Counter";
import Footer from "../components/Footer";
import wIcon from "../assets/icons/w-icon.svg";
import E1Icon from "../assets/icons/E1-icon.svg";
import E2Icon from "../assets/icons/E2-icon.svg";
import CIcon from "../assets/icons/C-icon.svg";
import AIcon from "../assets/icons/A-icon.svg";
import RIcon from "../assets/icons/R-icon.svg";
import SeconadaryBtn from "../components/SeconadaryBtn";
import AppointmentForm from "../components/AppointmentForm";
import PrimaryButton from "../components/PrimaryButton";
import CaringFromMiles from "../components/CaringFromMiles";
import logo from "../assets/images/logo.png";
import peaceofMind1 from "../assets/images/PeaceofMind1.jpg";
import peaceofMind2 from "../assets/images/PeaceofMind2.jpg";

export default function FamiliesCaring() {
  const [hovered, setHovered] = useState("about");
  const navigate = useNavigate();
  const promiseCards = [
    {
      letter: "W",
      title: "Wellness First",
      desc: "Every decision we make prioritizes patient well-being.",
    },
    {
      letter: "E",
      title: "Empathy Always",
      desc: "We treat every client like our own family.",
    },
    {
      letter: "C",
      title: "Compassion in Action",
      desc: "Genuine care is at the heart of what we do.",
    },
    {
      letter: "A",
      title: "Accountability",
      desc: "We are responsible for delivering on our promises.",
    },
    {
      letter: "R",
      title: "Respect & Dignity",
      desc: "Every patient deserves to be treated with honor.",
    },
    {
      letter: "E",
      title: "Excellence in Care",
      desc: "We uphold global medical standards.",
    },
  ];

  const steps = [
    {
      title: "Connection & Understanding",
      desc: "We begin with a comprehensive conversation with you to understand your parent’s health needs, preferences, and your expectations.",
    },
    {
      title: "Personalized Care Plan",
      desc: "Our clinical team designs a care plan tailored to your loved one’s medical needs, lifestyle, and cultural context—ensuring it aligns with the high standards you expect.",
    },
    {
      title: "Seamless Onboarding",
      desc: "We coordinate every detail—from medical history gathering to first visits—so you can focus on being present for your family emotionally.",
    },
    {
      title: "Transparent Communication",
      desc: "You’ll receive timely updates after each visit, along with clear health reports and recommendations. No wondering, no waiting.",
    },
    {
      title: "Continuous Improvement",
      desc: "We regularly review care plans, adapting to changes in your parent’s health while maintaining the highest quality of service.",
    },
  ];

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Services",
      active: hovered === "services" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("services"),
      onMouseLeave: () => setHovered("services"),
    },
  ];
  return (
    <div className="fc_page">
      <Header />

      {/* HERO SECTION */}
      <div className="fc_hero">
        <div className="fc_breadcrumbs">
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        <div
          className="fc_hero_bg"
          style={{ backgroundImage: `url(${familiesCaringbg})` }}
        />
        <div className="fc_hero_overlay" />

        <div className="fc_hero_content">
          <p className="fc_hero_subtitle">Families Caring</p>
          <h1 className="fc_hero_title">For Families Who Care From Afar</h1>
          <p className="fc_hero_description">
            You’ve built a life abroad, but your heart never left home. Now give
            your parents the same world-class care you’ve seen abroad—delivered
            right here in Cameroon.
          </p>

          <div className="fc_hero_buttons">
            <SeconadaryBtn
              label="Explore Services"
              onClick={() => navigate("/services")}
            />
          </div>
        </div>
      </div>

      {/* CARING FROM MILES SECTION */}
      <CaringFromMiles />

      {/* PROMISE SECTION */}
      <div className="fc_promise_section">
        <div className="fc_promise_header">
          <p className="fc_promise_title">Our Promise to You: W.E.C.A.R.E.</p>
          <p className="fc_promise_text">
            Our corporate values aren’t just words—they’re the foundation of
            every interaction, every decision, and every service we deliver.
          </p>
        </div>

        <div className="fc_promise_grid">
          {promiseCards.map((value, i) => (
            <div className="fc_promise_card" key={i}>
              <div className="fc_promise_letter">{value.letter}</div>
              <h3 className="fc_promise_cardTitle">{value.title}</h3>
              <p className="fc_promise_cardDesc">{value.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* STEPS SECTION */}
      <div className="fc_steps_section">
        <div className="fc_steps_header">
          <p className="fc_steps_title">Your Emotional Journey,</p>
          <p className="fc_steps_title">Our Guided Process</p>
        </div>

        <div className="fc_steps_grid">
          {steps.map((step, i) => (
            <div className="fc_steps_card" key={i}>
              <h3 className="fc_steps_cardTitle">{step.title}</h3>
              <p className="fc_steps_cardDesc">{step.desc}</p>
              <span className="fc_steps_number">{i + 1}</span>
            </div>
          ))}
        </div>
      </div>

      {/* PEACE OF MIND SECTION */}
      <div className="fc_peace_section">
        <div className="fc_peace_header">
          <h2 className="fc_peace_title">Peace of Mind, Wherever You Are</h2>
          <p className="fc_peace_text">
            When you entrust VeriMED with your parent's care, you're gaining a
            dedicated partner who understands your emotional journey and
            delivers peace of mind.
          </p>
        </div>

        <div className="fc_peace_images">
          <img
            src={peaceofMind1}
            className="fc_peace_img"
            alt="Peace of Mind 1"
          />
          <img src={logo} className="fc_peace_logo" alt="Logo" />
          <img
            src={peaceofMind2}
            className="fc_peace_img"
            alt="Peace of Mind 2"
          />
        </div>

        <p className="fc_peace_footer">
          VeriMED – Bringing Global-Standard Healthcare Home to Cameroon.
        </p>
      </div>

      <AppointmentForm />
      <Footer />
    </div>
  );
}
